import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ManifiestoRADDto;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Fecha de creación", cell: x => ({ data: kea.toDate(x.FechaCreacion) }) },
    { title: "Folio", cell: x => ({ data: x.Folio }) },
    { title: "Cliente", cell: x => ({ data: x.NombreCliente }) },
    { title: "Sucursal", cell: x => ({ data: x.NombreSucursal }) },
    { title: "Dirección", cell: x => ({ data: x.DireccionOrigen.Descripcion }) },
    { title: "Chofer", cell: x => ({ data: x.NombreChofer }) },
    { title: "Camion", cell: x => ({ data: x.NombreCamion }) },
    { title: "Cant. guías", cell: x => ({ data: x.CantidadGuias }) },
    { title: "Usuario capturó", cell: x => ({ data: x.NombreUsuarioCreacion }) },
    { title: "Fecha de terminado", cell: x => ({ data: kea.toDate(x.FechaTerminado) }) },
    { title: "Fecha de cancelado", cell: x => ({ data: kea.toDate(x.FechaCancelado) }) },
];

interface BotonesDeps {
    onImprimir: (x: Entity) => void;
    onVer: (x: Entity) => void;
    onCancelar: (x: Entity) => void;
    onTerminar: (x: Entity) => void;
    onTimbrarCartaPorteRAD: (x: Entity) => void;
    onImprimirCartaPorteRAD: (x: Entity) => void;
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps, permisos: models.Rol, HabilitarValidacionesCartaPorte: boolean ): Column[] {
    const botones = kea.columnaBotones([
        /*
            TODO: Terminar este bootón
            {
                iconClass: fa("eye"),
                onClick: deps.onVer,
                tooltip: "Ver",
            },*/
            /*
            {
                iconClass: fa("print"),
                onClick: deps.onImprimir,
                tooltip: "Imprimir manifiesto"
            },
        */ 
        {
            iconClass: fa("times"),
            style: "danger",
            tooltip: "Cancelar",
            onClick: deps.onCancelar,
            disabled: x => !permisos.ManifiestoRAD.VerBotonCancelarManifiesto || x.FechaTerminado != null
        },{
            iconClass: fa("bell"),
            tooltip: "Timbrar Carta Porte",
            style: "default",
            onClick: deps.onTimbrarCartaPorteRAD,
            //disabled: x => x.TieneXmlTimbrado
        },{
            iconClass: fa("print"),
            tooltip: "Imprimir carta porte timbrada",
            style: "default",
            onClick: deps.onImprimirCartaPorteRAD,
            disabled: x => !(x.TieneXmlTimbrado),
        }
        , {
            iconClass: fa("check"),
            style: "success",
            tooltip: "Terminar recolección",
            onClick: deps.onTerminar,
            disabled: x =>  
            x.FechaTerminado != null 
            || x.FechaCancelado != null 
            || !permisos.ManifiestoRAD.VerBotonTerminarManifiesto 
            || (HabilitarValidacionesCartaPorte ? !(x.TieneXmlTimbrado && x.TienexmlImpreso) : false)
        }
    ]);

    return [botones, ...columnasFijas];
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/manifiestorad/list/columns.tsx